import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui';
import { useTaskAction } from './useTaskAction';
import { SkipReasonGrid } from './SkipReasonGrid';
import type { SkipReason, Task } from '@/types';

export interface SkipReasonPopoverProps {
  task: Task;
  trigger: React.ReactNode;
  onSkipped?: () => void;
}

export function SkipReasonPopover({ task, trigger, onSkipped }: SkipReasonPopoverProps) {
  const [open, setOpen] = useState(false);
  const { skip } = useTaskAction();

  const onPick = (reason: SkipReason) => {
    skip(task.id, reason);
    setOpen(false);
    onSkipped?.();
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent side="top" align="end" className="w-56 p-2">
        <SkipReasonGrid onPick={onPick} />
      </PopoverContent>
    </Popover>
  );
}
